import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.436 9.144a.75.75 0 0 1 .174 1.047l-3.75 5.25a.75.75 0 0 1-1.14.094l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.624 1.623 3.236-4.53a.75.75 0 0 1 1.046-.174"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 12.005c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.366-9.75-9.75M12 3.755a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }